import React from "react";
import { AdminSuiteActionsProps } from "./AdminSuiteRequestsActions";
import AdminSuiteEmailConfirmation from "./AdminSuiteEmailConfirmation";

const AdminSuiteCancelledAction = ({ ...props }: AdminSuiteActionsProps) => {
  return <AdminSuiteEmailConfirmation {...props} />;
};

export default AdminSuiteCancelledAction;
